import { Button } from 'components/ui/button';
import { OrderDetailsCardTable } from 'components/Orders/OrderDetailsCards/OrderDetailsCardTable/orderDetailsCardTable';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as LeftArrowIcon } from 'assets/icons/left-arrow.svg';
import { Routes } from 'config/constants';
import { useEffect } from 'react';

export const OrderDetails = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (orderId?.startsWith('ci_')) {
      navigate(Routes.CheckoutIntents, { state: { checkoutIntentId: orderId } });
    }
  }, [orderId, navigate]);

  return (
    <div className="order-details-main-div">
      <div className="order-details-header">
        <div className="order-details-buttons-row">
          <Button
            type="button"
            variant="ghost"
            className="order-details-back-button order-details-buttons-row gap-3 px-0 hover:bg-transparent"
            onClick={() => navigate(-1)}
          >
            <LeftArrowIcon className="order-details-left-arrow-icon" />
            <h1 className="m-0 p-0 font-display text-2xl font-medium">Order Details</h1>
          </Button>
        </div>
      </div>
      {orderId && <OrderDetailsCardTable orderId={orderId} />}
    </div>
  );
};
